import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { BsChevronBarRight } from "react-icons/bs";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { formatMoney } from "../services/utils/helpersFunc";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";

export const LoanStatusBadge = ({ status }) => {
  const styles = {
    pending: { bg: "#FFF4D6", color: "#FF8A25" },
    approved: { bg: "#D3FDF0", color: "#09A775" },
    rejected: { bg: "#FFE0E0", color: "#FF4949" },
  };

  const currentStyle = styles[status] || styles.pending;

  return (
    <Text
      bg={currentStyle.bg}
      color={currentStyle.color}
      p="5px 10px"
      fontSize="10px"
      borderRadius="3px"
      fontWeight="500"
      fontFamily="satoshiBold"
      textAlign="center"
      textTransform="capitalize"
    >
      {status}
    </Text>
  );
};

const ListofLoans = () => {
  const navigate = useNavigate();
  const role = localStorage.getItem("role");
  const { loans } = useSelector((state) => state.loanRequest);

  const isAdmin = role === "Admin";

  const getStatus = (item) => {
    if (role === "Reporting") return item.sales_approval;
    if (role === "Finance Ops") return item.credit_approval;
    if (role === "Finance Admin") return item.finance_approval;
    if (role === "Verification") return item.verification_approval;
    return item.final_approval;
  };

  const adminColumns = [
    { header: "Date", accessor: (item) => moment(item.created_at).format("L") },
    { header: "Loan ID", accessor: "request_id" },
    { header: "Insurance Fee", accessor: "insurance_fee" },
    { header: "Processing Fee", accessor: "processing_fee" },
    { header: "Proposed Amount", accessor: "proposed_amount" },
    { header: "Proposed Tenure", accessor: "proposed_tenure" },
  ];

  const defaultColumns = [
    { header: "Date", accessor: (item) => moment(item.created_at).format("L") },
    { header: "First Name", accessor: "first_name" },
    { header: "Last Name", accessor: "last_name" },
    {
      header: "Date of birth",
      accessor: (item) => moment(item.dob).format("L"),
    },
    { header: "Email", accessor: "email" },
    { header: "Phone Number", accessor: "phone" },
    {
      header: "Loan Amount",
      accessor: (item) =>
        item.amount ? `₦ ${formatMoney(item.amount)}` : "N/A",
    },
    {
      header: "Status",
      accessor: (item) => <LoanStatusBadge status={getStatus(item)} />,
    },
  ];

  const columns = isAdmin ? adminColumns : defaultColumns;

  return (
    <Box bg="white" mt="20px">
      <TableContainer>
        <Table variant="simple">
          <Thead>
            <Tr>
              {columns.map((col, index) => (
                <Th
                  key={index}
                  textTransform="capitalize"
                  fontSize={["10px", "12px"]}
                  color="#262B40"
                  lineHeight="18px"
                  fontWeight="500"
                >
                  {col.header}
                </Th>
              ))}
              <Th />
            </Tr>
          </Thead>
          <Tbody>
            {loans?.map((item) => (
              <motion.tr
                key={item.request_id}
                whileHover={{ scale: 1.01 }}
                style={{ cursor: "pointer" }}
                onClick={() => navigate(`/requests/${item.request_id}`)}
              >
                {columns.map((col, index) => (
                  <Td
                    key={index}
                    fontSize={["10px", "12px"]}
                    color="#33343D"
                    lineHeight="18px"
                    fontWeight="500"
                    fontFamily="satoshiBold"
                  >
                    {typeof col.accessor === "function"
                      ? col.accessor(item)
                      : item[col.accessor]}
                  </Td>
                ))}
                <Td>
                  <BsChevronBarRight />
                </Td>
              </motion.tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ListofLoans;
